import { render, staticRenderFns } from "./CarCoinConfigure.vue?vue&type=template&id=88798d42&scoped=true"
import script from "./CarCoinConfigure.vue?vue&type=script&lang=js"
export * from "./CarCoinConfigure.vue?vue&type=script&lang=js"
import style0 from "./CarCoinConfigure.vue?vue&type=style&index=0&id=88798d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88798d42",
  null
  
)

export default component.exports